<template>
  <div>
    <div class="d-flex align-center mb-4">
      <v-icon color="primary" large class="mr-2">mdi-account-circle</v-icon>
      <h1>Mi Perfil</h1>
    </div>

    <v-row>
      <!-- ── Datos del perfil ──────────────────────────── -->
      <v-col cols="12" md="6">
        <v-card rounded="xl" class="elevation-2 pa-4">
          <v-card-title class="text-subtitle-1 font-weight-bold pb-3">
            <v-icon color="primary" class="mr-2">mdi-account-edit</v-icon>
            Información personal
          </v-card-title>

          <!-- Avatar -->
          <div class="d-flex justify-center mb-4">
            <v-avatar size="80" color="primary">
              <span class="white--text text-h4 font-weight-bold">
                {{ iniciales }}
              </span>
            </v-avatar>
          </div>

          <v-text-field
            v-model="perfil.nombre"
            label="Nombre completo"
            outlined dense rounded
            prepend-inner-icon="mdi-account"
            class="mb-2"
          />
          <v-text-field
            v-model="perfil.correo"
            label="Correo electrónico"
            type="email" outlined dense rounded
            prepend-inner-icon="mdi-email"
            class="mb-2"
          />
          <v-text-field
            v-model="perfil.telefono"
            label="Teléfono"
            outlined dense rounded
            prepend-inner-icon="mdi-phone"
            class="mb-2"
          />

          <v-btn color="primary" rounded block :loading="guardando" @click="guardarPerfil">
            <v-icon left>mdi-content-save</v-icon> Guardar cambios
          </v-btn>
        </v-card>
      </v-col>

      <!-- ── Cambiar contraseña ───────────────────────── -->
      <v-col cols="12" md="6">
        <v-card rounded="xl" class="elevation-2 pa-4">
          <v-card-title class="text-subtitle-1 font-weight-bold pb-3">
            <v-icon color="error" class="mr-2">mdi-lock-reset</v-icon>
            Cambiar contraseña
          </v-card-title>

          <v-text-field
            v-model="passwords.actual"
            label="Contraseña actual"
            :type="mostrarActual ? 'text' : 'password'"
            outlined dense rounded
            prepend-inner-icon="mdi-lock"
            :append-icon="mostrarActual ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="mostrarActual = !mostrarActual"
            class="mb-2"
          />
          <v-text-field
            v-model="passwords.nueva"
            label="Nueva contraseña"
            :type="mostrarNueva ? 'text' : 'password'"
            outlined dense rounded
            prepend-inner-icon="mdi-lock-plus"
            :append-icon="mostrarNueva ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="mostrarNueva = !mostrarNueva"
            :rules="[v => v.length >= 8 || 'Mínimo 8 caracteres']"
            class="mb-2"
          />
          <v-text-field
            v-model="passwords.confirmar"
            label="Confirmar nueva contraseña"
            :type="mostrarConfirmar ? 'text' : 'password'"
            outlined dense rounded
            prepend-inner-icon="mdi-lock-check"
            :append-icon="mostrarConfirmar ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="mostrarConfirmar = !mostrarConfirmar"
            :error-messages="passwords.nueva && passwords.confirmar && passwords.nueva !== passwords.confirmar ? ['Las contraseñas no coinciden'] : []"
            class="mb-2"
          />

          <v-btn color="error" rounded block :loading="cambiandoPass"
            :disabled="!passwords.actual || !passwords.nueva || passwords.nueva !== passwords.confirmar || passwords.nueva.length < 8"
            @click="cambiarPassword">
            <v-icon left>mdi-lock-reset</v-icon> Cambiar contraseña
          </v-btn>
        </v-card>

        <!-- Rol y sesión -->
        <v-card rounded="xl" class="elevation-2 pa-4 mt-4">
          <v-card-title class="text-subtitle-1 font-weight-bold pb-1">
            <v-icon color="indigo" class="mr-2">mdi-shield-account</v-icon>
            Sesión actual
          </v-card-title>
          <div class="d-flex align-center mt-2">
            <v-chip :color="rolColor" dark class="mr-2">
              <v-icon left small>mdi-account-key</v-icon>
              {{ perfil.rol || rol }}
            </v-chip>
            <v-chip color="green" dark x-small>
              <v-icon left x-small>mdi-circle</v-icon> Activo
            </v-chip>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <v-snackbar v-model="snack.show" :color="snack.color" top :timeout="3000">
      {{ snack.msg }}
    </v-snackbar>
  </div>
</template>

<script>
import HttpService from '../../Servicios/HttpService'

export default {
  name: 'MiPerfil',

  data() {
    return {
      perfil: {
        nombre:   localStorage.getItem('nombreUsuario') || '',
        correo:   '',
        telefono: '',
        rol:      '',
      },
      passwords:      { actual: '', nueva: '', confirmar: '' },
      mostrarActual:  false,
      mostrarNueva:   false,
      mostrarConfirmar: false,
      guardando:      false,
      cambiandoPass:  false,
      rol:            localStorage.getItem('rolUsuario') || '',
      snack: { show: false, msg: '', color: 'success' },
    }
  },

  computed: {
    iniciales() {
      return (this.perfil.nombre || 'A').split(' ').map(n => n[0]).join('').toUpperCase().slice(0,2)
    },
    rolColor() {
      const r = (this.perfil.rol || this.rol)
      return r === 'admin' ? 'indigo' : r === 'recepcionista' ? 'teal' : 'orange darken-2'
    },
  },

  mounted() {
    this.cargarPerfil()
  },

  methods: {
    async cargarPerfil() {
      const r = await HttpService.registrar({
        metodo:    'mi_perfil',
        idUsuario: localStorage.getItem('idUsuario'),
      }, 'usuarios.php')
      if (r && r.usuario) {
        this.perfil = {
          nombre:   r.usuario.nombre   || this.perfil.nombre,
          correo:   r.usuario.correo   || '',
          telefono: r.usuario.telefono || '',
          rol:      r.usuario.rol      || '',
        }
      }
    },

    async guardarPerfil() {
      this.guardando = true
      const r = await HttpService.registrar({
        metodo:    'actualizar_perfil',
        idUsuario: localStorage.getItem('idUsuario'),
        nombre:    this.perfil.nombre,
        correo:    this.perfil.correo,
        telefono:  this.perfil.telefono,
      }, 'usuarios.php')
      this.guardando = false
      if (r && r.ok) {
        localStorage.setItem('nombreUsuario', this.perfil.nombre)
        this.snack = { show: true, msg: 'Perfil actualizado ✓', color: 'success' }
      } else {
        this.snack = { show: true, msg: 'Error al guardar', color: 'error' }
      }
    },

    async cambiarPassword() {
      this.cambiandoPass = true
      const r = await HttpService.registrar({
        metodo:          'cambiar_pass',
        idUsuario:       localStorage.getItem('idUsuario'),
        passwordActual:  this.passwords.actual,
        passwordNueva:   this.passwords.nueva,
      }, 'usuarios.php')
      this.cambiandoPass = false
      if (r && r.resultado) {
        this.snack = { show: true, msg: 'Contraseña cambiada exitosamente ✓', color: 'success' }
        this.passwords = { actual: '', nueva: '', confirmar: '' }
      } else {
        this.snack = { show: true, msg: (r && r.error) ? r.error : 'Contraseña actual incorrecta', color: 'error' }
      }
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/MiPerfil.vue